import styles from './tabs.module.css'

export const tabStyles = {
    buttonContainer: `whitespace-nowrap flex overflow-x-auto md:overflow-x-auto items-center relative w-full ${styles.buttonContainer}`, 
    button: `min-w-[180px] text-center px-2 py-1.5 pb-2 text-white text-[15px] font-[400] relative ${styles.tab_btn} ${styles.button} 
             md:px-2 md:py-2.5 md:text-[14px]
    `,
    activeTab: `${styles.activeTab}`,
    leftIcon: `absolute left-0 transform p-0 cursor-pointer z-10 bg-gradient-to-r from-[#B98B00] to-transparent transition-all duration-300`,
    rightIcon: `absolute right-0 transform p-0 cursor-pointer z-10 bg-gradient-to-l from-[#B98B00] to-transparent transition-all duration-300`,
};